import { ChangeEvent } from "react";
import React, { FC, memo } from "../../../lib/teact/teact";
import './myTextInput.scss'
import buildClassName from "../../../util/buildClassName";
type OwnProps = {
    value?: string | number;
    label: string;
    id?: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    inputClassName?: '2.5' | '3.5' | '4.5' | '5.5' | '6.5' | 'full-width',
    isPassword?: boolean;
    inputMode?: 'text' | 'none' | 'tel' | 'url' | 'email' | 'numeric' | 'decimal' | 'search';
}
const MyTextInput: FC<OwnProps> = ({
    value,
    label,
    onChange,
    id,
    className,
    inputClassName,
    isPassword,
    inputMode,
}) => {
    let extrarClass = 'input-field';
    const safeId = id || `input-${Math.random().toString(36).substring(2, 9)}`;
    switch (inputClassName) {
        case '2.5':
            extrarClass = 'input-field-25';
            break;
        case '3.5':
            extrarClass = 'input-field-35';
            break;
        case '4.5':
            extrarClass = 'input-field-45';
            break;
        case '5.5':
            extrarClass = 'input-field-55';
            break;
        case '6.5':
            extrarClass = 'input-field-65';
            break;
        case 'full-width':
            extrarClass = 'input-field-full-width';
            break;
    }
    return (
        <div className="input-container">
            <label htmlFor={id} className={buildClassName("input-label")}>{label}</label>
            <input type={isPassword ? "password" : "text"}
                id={id ? id : safeId} className={buildClassName(extrarClass, className)}
                inputMode={inputMode}
                value={value}
                onChange={onChange} />
        </div>
    )
}
export default memo(MyTextInput)